import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { count } from 'rxjs/operators';
import { AuthService } from 'src/app/_services/auth.service';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';

declare var require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);
HC_exporting(Highcharts);

@Component({
  selector: 'app-chemistshop-dashboard',
  templateUrl: './chemistshop-dashboard.component.html',
  styleUrls: ['./chemistshop-dashboard.component.css']
})
export class ChemistshopDashboardComponent implements OnInit {

  public options: any = {
      chart: {
          type: 'area'
      },
      title: {
          text: 'Sale Chart'
      },
    
      yAxis: {
          title: {
              useHTML: true,
              text: 'Amount'
          }
      },
      tooltip: {
          shared: true,
          headerFormat: '<span style="font-size:12px"><b>{point.key}</b></span><br>'
      },
      credits:{
        enabled: false
      },
      exporting:{
        enabled: true
      },
      plotOptions: {
          series: {
              pointStart: 2024
          },
          area: {
              stacking: 'normal',
              lineColor: '#666666',
              lineWidth: 1,
              marker: {
                  lineWidth: 1,
                  lineColor: '#666666'
              }
          }
      },
      series: [{
          name: 'Ebay',
          data: [13234, 12729, 11533, 17798, 10398, 12811, 15483, 16196, 16214]
      }, {
          name: 'Groupon',
          data: [6685, 6535, 6389, 6384, 6251, 5725, 5631, 5047, 5039]
  
      }, {
          name: 'On Buy',
          data: [4752, 4820, 4877, 4925, 5006, 4976, 4946, 4911, 4913]
      }]
    };
  
  
    headerColor = 'primary';
    constructor(private titleService: Title, 
      private router:Router,
      public authService : AuthService) { }
  
    ngOnInit() {
      this.titleService.setTitle('Main Dashboard');
      Highcharts.chart('area-chart-container', this.options);
    }
  
  
  
  
  }
  
  
  